import React, { useState } from 'react';
import './principal.css';
import logo from '../../../assets/images/Pathways_Logo.png';
import XLSX from 'xlsx-js-style';
import { useQuery, useLazyQuery } from '@apollo/client';
import { getPowerBankByTagId, getExternalDiskByTagId, getGeneralInventoryByTagId, getBackupBatteryByTagId, getExtensionCordByTagId, getHeadsetByTagId, getSuppliesByTagId, getDockingStationByTagId, getSpeakerByTagId, getPhoneByTagId, getLaptopByTagId, getProjectorByTagId, getMonitorByTagId, getMouseByTagId, getKeyboardByTagId, getScannerByTagId, getPrinterByTagId, getTabletRemarkableByTagId, getUSBByTagId } from '../../../graphql/queries';
import { listDeleteEquipmentHistoryFixes, listMonitorFixes, listPhoneFixes, listLaptopFixes, listMouseFixes, listKeyboardFixes, listScannerFixes, listPrinterFixes, listExtensionCordFixes, listPowerBankFixes, listBackupBatteryFixes, listUSBFixes, listDockingStationFixes, listSpeakerFixes, listTabletRemarkableFixes, listHeadsetFixes, listGeneralInventoryFixes } from '../../../graphql/queries';
import { useNavigate } from 'react-router-dom';
import { capitalize } from '../../../components/common/capitalize';
import { Users, Monitor, Box, QrCode, Sofa } from 'lucide-react';


const Inventory_Home = () => {


    // Estado para manejar el valor seleccionado
    const [selectedEquipment, setSelectedEquipment] = useState('');
    const [selectedDate, setSelectedDate] = useState('');
    const [showOverlay, setShowOverlay] = useState(false);
    const [selectedTagInfo, setSelectedTagInfo] = useState(null);
    const [searchTag, setSearchTag] = useState("");

    const { data: userData1 } = useQuery(listMonitorFixes);
    const { data: userData2 } = useQuery(listPhoneFixes);
    const { data: userData3 } = useQuery(listLaptopFixes);
    const { data: userData4 } = useQuery(listMouseFixes);
    const { data: userData5 } = useQuery(listKeyboardFixes);
    const { data: userData6 } = useQuery(listScannerFixes);
    const { data: userData7 } = useQuery(listPrinterFixes);
    const { data: userData8 } = useQuery(listExtensionCordFixes);
    const { data: userData9 } = useQuery(listPowerBankFixes);
    const { data: userData10 } = useQuery(listBackupBatteryFixes);
    const { data: userData11 } = useQuery(listUSBFixes);
    const { data: userData12 } = useQuery(listDockingStationFixes);
    const { data: userData13 } = useQuery(listSpeakerFixes);
    const { data: userData14 } = useQuery(listTabletRemarkableFixes);
    const { data: userData15 } = useQuery(listHeadsetFixes);
    const { data: userData16 } = useQuery(listGeneralInventoryFixes);
    const { data: userData17 } = useQuery(listDeleteEquipmentHistoryFixes);


    //Search general By TagId
    const [getMonitorByTag, { data: monitorData }] = useLazyQuery(getMonitorByTagId);
    const [getLaptopByTag, { data: laptopData }] = useLazyQuery(getLaptopByTagId);
    const [getPhoneByTag, { data: phoneData }] = useLazyQuery(getPhoneByTagId);
    const [getProjectorByTag, { data: projectorData }] = useLazyQuery(getProjectorByTagId);
    const [getMouseByTag, { data: mouseData }] = useLazyQuery(getMouseByTagId);
    const [getKeyboardByTag, { data: keyboarData }] = useLazyQuery(getKeyboardByTagId);
    const [getScannerByTag, { data: scannerData }] = useLazyQuery(getScannerByTagId);
    const [getPrinterByTag, { data: printerData }] = useLazyQuery(getPrinterByTagId);
    const [getTabletRemarkableByTag, { data: tabletRemarkableData }] = useLazyQuery(getTabletRemarkableByTagId);
    const [getUSBByTag, { data: USBData }] = useLazyQuery(getUSBByTagId);
    const [getDockingStationByTag, { data: DockingStationData }] = useLazyQuery(getDockingStationByTagId);
    const [getSpeakerByTag, { data: SpeakerData }] = useLazyQuery(getSpeakerByTagId);
    const [getHeadsetByTag, { data: headsetData }] = useLazyQuery(getHeadsetByTagId);
    const [getSuppliesByTag, { data: suppliesData }] = useLazyQuery(getSuppliesByTagId);
    const [getExtensionCordByTag, { data: extensionCordData }] = useLazyQuery(getExtensionCordByTagId);
    const [getBackupBatteryByTag, { data: backupBatteryData }] = useLazyQuery(getBackupBatteryByTagId);
    const [getGeneralInventoryByTag, { data: generalInventoryData }] = useLazyQuery(getGeneralInventoryByTagId);
    const [getExternalDiskByTag, { data: externalDiskData }] = useLazyQuery(getExternalDiskByTagId);
    const [getPowerBankByTag, { data: powerBankData }] = useLazyQuery(getPowerBankByTagId);


    const navigate = useNavigate();

    const handleDateChange = (event) => {
        setSelectedDate(event.target.value);
    };

    // Maneja el cambio de selección en el <select> para selectedEquipment
    const handleEquipmentChange = (event) => {
        setSelectedEquipment(event.target.value);
    };

    const handleClick = () => {
        if (selectedEquipment) {
            navigate(`../equipment-${selectedEquipment}`);
        } else if (selectedDate) {
            navigate(`../equipment-report-by-date`, { state: { selectedDate } });
        }
    };

    //  data una vez que las verificaciones de errores y carga se han realizado
    const monitors = React.useMemo(() => (userData1 && userData1.listMonitorFixes ? userData1.listMonitorFixes.items : []), [userData1]);
    const phones = React.useMemo(() => (userData2 && userData2.listPhoneFixes ? userData2.listPhoneFixes.items : []), [userData2]);
    const laptops = React.useMemo(() => (userData3 && userData3.listLaptopFixes ? userData3.listLaptopFixes.items : []), [userData3]);
    const mice = React.useMemo(() => (userData4 && userData4.listMouseFixes ? userData4.listMouseFixes.items : []), [userData4]);
    const keyboards = React.useMemo(() => (userData5 && userData5.listKeyboardFixes ? userData5.listKeyboardFixes.items : []), [userData5]);
    const scanners = React.useMemo(() => (userData6 && userData6.listScannerFixes ? userData6.listScannerFixes.items : []), [userData6]);
    const printers = React.useMemo(() => (userData7 && userData7.listPrinterFixes ? userData7.listPrinterFixes.items : []), [userData7]);
    const extensionCords = React.useMemo(() => (userData8 && userData8.listExtensionCordFixes ? userData8.listExtensionCordFixes.items : []), [userData8]);
    const powerBanks = React.useMemo(() => (userData9 && userData9.listPowerBankFixes ? userData9.listPowerBankFixes.items : []), [userData9]);
    const backupBatteries = React.useMemo(() => (userData10 && userData10.listBackupBatteryFixes ? userData10.listBackupBatteryFixes.items : []), [userData10]);
    const usb = React.useMemo(() => (userData11 && userData11.listUSBFixes ? userData11.listUSBFixes.items : []), [userData11]);
    const dockingStations = React.useMemo(() => (userData12 && userData12.listDockingStationFixes ? userData12.listDockingStationFixes.items : []), [userData12]);
    const speakers = React.useMemo(() => (userData13 && userData13.listSpeakerFixes ? userData13.listSpeakerFixes.items : []), [userData13]);
    const tablets = React.useMemo(() => (userData14 && userData14.listTabletRemarkableFixes ? userData14.listTabletRemarkableFixes.items : []), [userData14]);
    const headset = React.useMemo(() => (userData15 && userData15.listHeadsetFixes ? userData15.listHeadsetFixes.items : []), [userData15]);
    const generalInventory = React.useMemo(() => (userData16 && userData16.listGeneralInventoryFixes ? userData16.listGeneralInventoryFixes.items : []), [userData16]);
    const deleteEquip = React.useMemo(() => (userData17 && userData17.listDeleteEquipmentHistoryFixes ? userData17.listDeleteEquipmentHistoryFixes.items : []), [userData17]);

    const handleAllInventory = async () => {
        try {
            const workbook = XLSX.utils.book_new();

            // Función auxiliar para crear una hoja de trabajo para una categoría específica
            const createWorksheet = (data, title) => {
                // Ordenar los datos por Timestamp en orden ascendente
                const sortedData = [...data].sort((a, b) => new Date(a.Timestamp) - new Date(b.Timestamp));

                // Preparar datos para exportación con títulos personalizados
                const worksheetData = sortedData.map((item, index) => {

                    const formattedPurchaseDate = item.purchase_date
                        ? new Date(item.purchase_date).toLocaleDateString('en-US') // Cambia el formato a MM/DD/YYYY
                        : '';

                    const rowData = {
                        '#': index + 1,
                        'TAG:': item.tagid || item.tagId,
                        'Brand': item.brand || "",
                        'Serial Number:': item.serial_Number,
                    };

                    // Solo agregar la columna "Type" si el título es "Monitors"
                    if (title === 'Monitors') {
                        rowData['Type:'] = item.monitor_type;
                    }
                    if (title === 'Phones') {
                        rowData['Cell Number:'] = item.cel_number;
                    }
                    if (title === 'Broken Equipment') {
                        rowData['Item Name:'] = item.Item;
                    }
                    rowData['Available:'] = item.available ? 'Yes' : 'No';
                    rowData['Status:'] = item.status || "";
                    rowData['Assigned to:'] = item.user
                        ? `${capitalize(item.user.first_name) || ''} ${capitalize(item.user.last_name) || ''}`.trim() || capitalize(item.previous_employees)
                        : capitalize(item.previous_employees);
                    rowData['Price:'] = item.price;
                    rowData['Purchase Date:'] = formattedPurchaseDate;
                    rowData['Team:'] = item.team || "";
                    rowData['Location:'] = item.location;

                    return rowData;
                });

                // Crear la hoja de trabajo y agregar el título
                const worksheet = XLSX.utils.json_to_sheet([]);
                XLSX.utils.sheet_add_aoa(worksheet, [[title]], { origin: 'A1' });

                // Agregar datos a partir de la fila A2
                XLSX.utils.sheet_add_json(worksheet, worksheetData, { origin: 'A2', skipHeader: false });

                // Definir el rango de referencia
                const endRow = worksheetData.length + 1;
                const endCol = Object.keys(worksheetData[0]).length - 1;
                worksheet['!ref'] = XLSX.utils.encode_range({ s: { r: 0, c: 0 }, e: { r: endRow, c: endCol } });

                // Fusionar celdas del título
                worksheet['!merges'] = worksheet['!merges'] || [];
                worksheet['!merges'].push({ s: { r: 0, c: 0 }, e: { r: 0, c: endCol } });


                // Style the title row
                worksheet['A1'].s = {
                    font: {
                        bold: true,
                        sz: 20, // Font size
                        color: { rgb: '1F4E79' } // Dark blue text color
                    },
                    alignment: {
                        horizontal: 'center',
                        vertical: 'center'
                    }
                };

                // Apply styling for the header row (now starting at row 2)
                const headerRange = XLSX.utils.decode_range(worksheet['!ref']);
                for (let col = headerRange.s.c; col <= headerRange.e.c; col++) {
                    const cellAddress = XLSX.utils.encode_cell({ r: 1, c: col }); // Header row is now row 1
                    if (!worksheet[cellAddress]) continue;
                    worksheet[cellAddress].s = {
                        fill: {
                            fgColor: { rgb: '1F4E79' } // Dark blue background
                        },
                        font: {
                            bold: true,
                            color: { rgb: 'FFFFFF' } // White text
                        },
                        alignment: {
                            horizontal: 'center'
                        },
                        border: {
                            top: { style: 'thin', color: { rgb: '000000' } },
                            left: { style: 'thin', color: { rgb: '000000' } },
                            bottom: { style: 'thin', color: { rgb: '000000' } },
                            right: { style: 'thin', color: { rgb: '000000' } },
                        }
                    };
                }

                // Apply alternating row colors and borders starting from row 3
                for (let row = 2; row <= headerRange.e.r; row++) {
                    const isEvenRow = row % 2 === 0;
                    for (let col = headerRange.s.c; col <= headerRange.e.c; col++) {
                        const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
                        if (!worksheet[cellAddress]) continue;

                        worksheet[cellAddress].s = {
                            fill: {
                                fgColor: { rgb: isEvenRow ? 'D3D3D3' : 'FFFFFF' } // Light gray for even rows, white for odd rows
                            },
                            border: {
                                top: { style: 'thin', color: { rgb: '000000' } },
                                left: { style: 'thin', color: { rgb: '000000' } },
                                bottom: { style: 'thin', color: { rgb: '000000' } },
                                right: { style: 'thin', color: { rgb: '000000' } },
                            },
                            alignment: {
                                horizontal: 'center'
                            }
                        };
                    }
                }

                // Configurar anchos de columna (sin aplicar estilos de celda)
                worksheet['!cols'] = [
                    { wch: 5 }, { wch: 10 }, { wch: 30 }, { wch: 30 }, { wch: 10 },
                    { wch: 10 }, { wch: 30 }, { wch: 10 }, { wch: 30 }, { wch: 5 }, { wch: 20 }, { wch: 25 }, { wch: 25 },

                ];

                return worksheet;
            };


            // Agregar cada categoría al libro de trabajo
            if (laptops.length > 0) XLSX.utils.book_append_sheet(workbook, createWorksheet(laptops, 'Laptops'), 'Laptops');
            if (phones.length > 0) XLSX.utils.book_append_sheet(workbook, createWorksheet(phones, 'Phones'), 'Phones');
            if (monitors.length > 0) XLSX.utils.book_append_sheet(workbook, createWorksheet(monitors, 'Monitors'), 'Monitors');
            if (mice.length > 0) XLSX.utils.book_append_sheet(workbook, createWorksheet(mice, 'Mice'), 'Mice');
            if (keyboards.length > 0) XLSX.utils.book_append_sheet(workbook, createWorksheet(keyboards, 'Keyboards'), 'Keyboards');
            if (scanners.length > 0) XLSX.utils.book_append_sheet(workbook, createWorksheet(scanners, 'Scanners'), 'Scanners');
            if (printers.length > 0) XLSX.utils.book_append_sheet(workbook, createWorksheet(printers, 'Printers'), 'Printers');
            if (extensionCords.length > 0) XLSX.utils.book_append_sheet(workbook, createWorksheet(extensionCords, 'Extension Cords'), 'Extension Cords');
            if (powerBanks.length > 0) XLSX.utils.book_append_sheet(workbook, createWorksheet(powerBanks, 'Power Banks'), 'Power Banks');
            if (backupBatteries.length > 0) XLSX.utils.book_append_sheet(workbook, createWorksheet(backupBatteries, 'Backup Batteries'), 'Backup Batteries');
            if (usb.length > 0) XLSX.utils.book_append_sheet(workbook, createWorksheet(usb, 'USB'), 'USB');
            if (dockingStations.length > 0) XLSX.utils.book_append_sheet(workbook, createWorksheet(dockingStations, 'Docking Stations'), 'Docking Stations');
            if (tablets.length > 0) XLSX.utils.book_append_sheet(workbook, createWorksheet(tablets, 'Tablets'), 'Tablets');
            if (speakers.length > 0) XLSX.utils.book_append_sheet(workbook, createWorksheet(speakers, 'Speakers'), 'Speakers');
            if (headset.length > 0) XLSX.utils.book_append_sheet(workbook, createWorksheet(headset, 'Headsets'), 'Headsets');
            if (generalInventory.length > 0) XLSX.utils.book_append_sheet(workbook, createWorksheet(generalInventory, 'Media && Other Equipment'), 'Media && Other Equipment');
            if (deleteEquip.length > 0) XLSX.utils.book_append_sheet(workbook, createWorksheet(deleteEquip, 'Broken Equipment'), 'Broken Equipment');

            // Exportar el libro de trabajo
            XLSX.writeFile(workbook, 'InventoryData.xlsx');

        } catch (error) {
            console.error('Error exporting data to Excel:', error);
        }
    };
    const options = [
        { value: "mouse", label: "Mouse" },
        { value: "keyboard", label: "Keyboard" },
        { value: "monitor", label: "Monitor" },
        { value: "scanner", label: "Scanner" },
        { value: "printer", label: "Printer" },
        { value: "extension-cord", label: "Extension Cord" },
        { value: "phone", label: "Phone" },
        { value: "power-bank", label: "Power Bank" },
        { value: "backup-battery", label: "Backup Battery" },
        { value: "usb", label: "USB Drive" },
        { value: "docking-station", label: "Docking Station" },
        { value: "speaker", label: "Speaker" },
        { value: "laptop", label: "Laptop" },
        { value: "tablet-remarkable", label: "Tablet && Remarkable" },
        { value: "headset", label: "Headset" },
        { value: "projector", label: "Projector" },
        { value: "external-disk", label: "External Disk" },
        { value: "other-equipment", label: "Media && Other Equipment" },
        { value: "bag", label: "Bag" },
        { value: "click-counter", label: "Click Counter" },
        { value: "office-supplies", label: "Office Supplies" },
        { value: "key", label: "Key" },
    ];

    // Ordenar las opciones alfabéticamente por etiqueta
    const sortedOptions = options.sort((a, b) => a.label.localeCompare(b.label));

    // Search General
    const handleSearchByTag = async () => {
        const tag = searchTag.trim().toLowerCase();

        if (!tag) {
            alert("Please enter a TAG.");
            return;
        }

        try {
            //--Laptop--//
            const { data: laptopData } = await getLaptopByTag({ variables: { tagid: tag } });
            const laptopItems = laptopData?.laptopFixByTagId?.items;

            if (laptopItems && laptopItems.length > 0) {
                setSelectedTagInfo(laptopItems[0]);
                setShowOverlay(true);
                return;
            }
            //--Phone--//
            const { data: phoneData } = await getPhoneByTag({ variables: { tagid: tag } });
            const PhoneItems = phoneData?.phoneFixByTagId?.items;

            if (PhoneItems && PhoneItems.length > 0) {
                setSelectedTagInfo(PhoneItems[0]);
                setShowOverlay(true);
                return;
            }
            //--Projector--//
            const { data: projectorData } = await getProjectorByTag({ variables: { tagId: tag } });
            const ProjectorItems = projectorData?.projectorByTagId?.items;

            if (ProjectorItems && ProjectorItems.length > 0) {
                setSelectedTagInfo(ProjectorItems[0]);
                setShowOverlay(true);
                return;
            }
            //--Monitor--//
            const { data: monitorData } = await getMonitorByTag({ variables: { tagid: tag } });
            const MonitorItems = monitorData?.monitorFixByTagId?.items;

            if (MonitorItems && MonitorItems.length > 0) {
                setSelectedTagInfo(MonitorItems[0]);
                setShowOverlay(true);
                return;
            }
            //--Mouse--//
            const { data: mouseData } = await getMouseByTag({ variables: { tagId: tag } });
            const MouseItems = mouseData?.mouseFixByTagId?.items;

            if (MouseItems && MouseItems.length > 0) {
                setSelectedTagInfo(MouseItems[0]);
                setShowOverlay(true);
                return;
            }
            //--Keyboard--//
            const { data: keyboarData } = await getKeyboardByTag({ variables: { tagid: tag } });
            const KeyboardItems = keyboarData?.keyboardFixByTagId?.items;

            if (KeyboardItems && KeyboardItems.length > 0) {
                setSelectedTagInfo(KeyboardItems[0]);
                setShowOverlay(true);
                return;
            }
            //--Scanner--// 
            const { data: scannerData } = await getScannerByTag({ variables: { tagid: tag } });
            const ScannerItems = scannerData?.ScannerFixByTagId?.items;

            if (ScannerItems && ScannerItems.length > 0) {
                setSelectedTagInfo(ScannerItems[0]);
                setShowOverlay(true);
                return;
            }

            //--Printer--//
            const { data: printerData } = await getPrinterByTag({ variables: { tagid: tag } });
            const PrinterItems = printerData?.printerFixByTagId?.items;

            if (PrinterItems && PrinterItems.length > 0) {
                setSelectedTagInfo(PrinterItems[0]);
                setShowOverlay(true);
                return;
            }
            //--Tablet--//
            const { data: tabletRemarkableData } = await getTabletRemarkableByTag({ variables: { tagid: tag } });
            const TabletRemarkableItems = tabletRemarkableData?.tabletRemarkableFixByTagId?.items;

            if (TabletRemarkableItems && TabletRemarkableItems.length > 0) {
                setSelectedTagInfo(TabletRemarkableItems[0]);
                setShowOverlay(true);
                return;
            }
            //--USB--//
            const { data: USBData } = await getUSBByTag({ variables: { tagid: tag } });
            const USBItems = USBData?.usbFixByTagId?.items;

            if (USBItems && USBItems.length > 0) {
                setSelectedTagInfo(USBItems[0]);
                setShowOverlay(true);
                return;
            }

            //--DockingStation--//
            const { data: DockingStationData } = await getDockingStationByTag({ variables: { tagid: tag } });
            const DockingStationItems = DockingStationData?.dockingStationFixByTagId?.items;

            if (DockingStationItems && DockingStationItems.length > 0) {
                setSelectedTagInfo(DockingStationItems[0]);
                setShowOverlay(true);
                return;
            }

            //--Speaker--//
            const { data: SpeakerData } = await getSpeakerByTag({ variables: { tagid: tag } });
            const SpeakerItems = SpeakerData?.speakerFixByTagId?.items;

            if (SpeakerItems && SpeakerItems.length > 0) {
                setSelectedTagInfo(SpeakerItems[0]);
                setShowOverlay(true);
                return;
            }
            //--Headset--//
            const { data: HeadsetData } = await getHeadsetByTag({ variables: { tagid: tag } });
            const HeadsetItems = HeadsetData?.headsetFixByTagId?.items;

            if (HeadsetItems && HeadsetItems.length > 0) {
                setSelectedTagInfo(HeadsetItems[0]);
                setShowOverlay(true);
                return;
            }

            //--Supplies--//
            const { data: SuppliesData } = await getSuppliesByTag({ variables: { tagId: tag } });
            const SuppliesItems = SuppliesData?.suppliesFixByTagId?.items;

            if (SuppliesItems && SuppliesItems.length > 0) {
                setSelectedTagInfo(SuppliesItems[0]);
                setShowOverlay(true);
                return;
            }
            //--ExtensionCord--//
            const { data: ExtensionCordData } = await getExtensionCordByTag({ variables: { tagid: tag } });
            const ExtensionCordItems = ExtensionCordData?.extensionCordFixByTagId?.items;

            if (ExtensionCordItems && ExtensionCordItems.length > 0) {
                setSelectedTagInfo(ExtensionCordItems[0]);
                setShowOverlay(true);
                return;
            }
            //--BackupBattery--//
            const { data: BackupBatteryData } = await getBackupBatteryByTag({ variables: { tagid: tag } });
            const BackupBatteryItems = BackupBatteryData?.backuckBatteryFixByTagId?.items;

            if (BackupBatteryItems && BackupBatteryItems.length > 0) {
                setSelectedTagInfo(BackupBatteryItems[0]);
                setShowOverlay(true);
                return;
            }
            //--Other Equipment--//
            const { data: generalInventoryData } = await getGeneralInventoryByTag({ variables: { tagid: tag } });
            const generalInventoryItems = generalInventoryData?.generalInventoryFixByTagId?.items;

            if (generalInventoryItems && generalInventoryItems.length > 0) {
                setSelectedTagInfo(generalInventoryItems[0]);
                setShowOverlay(true);
                return;
            }
            //--External Disk--//
            const { data: ExternalDiskData } = await getExternalDiskByTag({ variables: { tagid: tag } });
            const ExternalDiskItems = ExternalDiskData?.externalDiskFixByTagId?.items;

            if (ExternalDiskItems && ExternalDiskItems.length > 0) {
                setSelectedTagInfo(ExternalDiskItems[0]);
                setShowOverlay(true);
                return;
            }
            //--Power Bank--//
            const { data: PowerBankData } = await getPowerBankByTag({ variables: { tagid: tag } });
            const PowerBankItems = PowerBankData?.powerBankFixByTagId?.items;

            if (PowerBankItems && PowerBankItems.length > 0) {
                setSelectedTagInfo(PowerBankItems[0]);
                setShowOverlay(true);
                return;
            }
            // 3. Si no se encontró en ninguno
            alert("TAG not found in inventory.");

        } catch (error) {
            console.error("❌ Error searching by TAG:", error);
            alert("An error occurred while searching. Please try again.");
        }
    };


    return (

        <div className="general-container">
            <header className="principal-container">
                <h1>Inventory Home</h1>
                <div className="principal-logo-container" >
                    <img src={logo} alt="logo" className="principal-logo" />
                </div>
            </header>


            <div className="principal-box">

                <section id="employees" className="principal-form">
                    <div id="employee-header" className="employee-header">
                        <h2>   <Users size={20} style={{ marginRight: "8px", verticalAlign: "middle" }} />Employees</h2>
                        <div id="employee-content" className="employee-content">
                            <button className="add-inventory-btn" onClick={() => navigate('../inventory-employees')}>+ Add/Edit Employee</button>
                            <button className="add-inventory-btn" onClick={() => navigate('../inventory-previous-employees')}> Previous  Employees</button>
                        </div>
                    </div>
                </section>

                <section id="equipment" className="principal-form">
                    <h2>  <Monitor size={20} style={{ marginRight: "8px", verticalAlign: "middle" }} />Equipments</h2>
                    <select id="equipment-select" className="select-box" value={selectedEquipment} onChange={handleEquipmentChange}>
                        <option value="" disabled>Select Equipment</option>
                        {sortedOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                    <button className="add-inventory-btn" onClick={handleClick} disabled={!selectedEquipment}>+ Add / Edit Equipment </button>
                    <button className="add-inventory-btn" onClick={() => navigate('../inventory-removed-equipment')}> Equipment Removed From Inventory:</button>
                    <button className="add-inventory-btn" onClick={handleAllInventory}>Export All Inventory to Excel:</button>
                </section>
                <section className="principal-form search-tag-section">
                    <h2><QrCode size={20} style={{ marginRight: "8px", verticalAlign: "middle" }} />TAG Lookup</h2>
                    <input
                        type="text"
                        placeholder="Enter TAG (e.g. 1-1812)"
                        value={searchTag}
                        onChange={(e) => setSearchTag(e.target.value)}
                    />
                    <button
                        className="add-inventory-btn"
                        onClick={handleSearchByTag}
                    >
                        View Info
                    </button>

                </section>


                <section id2="all" className="principal-form">
                    <h2> <Box size={20} style={{ marginRight: "8px", verticalAlign: "middle" }} />Inventory Report</h2>

                    <select id="selected-Date" value={selectedDate} className="select-box" onChange={handleDateChange}>
                        <option value="" disabled>Type Date</option>
                        <option value="purchase_date"> Purchase Date</option>
                        <option value="returnable_date"> Returnable Date</option>
                        <option value="warranty_date">Warranty Date</option>

                    </select>
                    <button className="add-inventory-btn" onClick={handleClick} disabled={!selectedDate}>Create Inventory Report by dates:</button>


                </section>
                {showOverlay && selectedTagInfo && (
                    <div className="overlay-search" onDoubleClick={() => setShowOverlay(false)}>
                        <div className="overlay-content-search" onClick={(e) => e.stopPropagation()}>
                            <h3>Equipment Details</h3>


                            {Object.entries(selectedTagInfo).map(([key, value]) => {
                                // Ignorar __typename y campos vacíos
                                if (!value || key === "id" || key === "userId") return null;

                                // Convertir camelCase o snake_case a Title Case
                                const formatLabel = key
                                    .replace(/_/g, " ")
                                    .replace(/([a-z])([A-Z])/g, "$1 $2")
                                    .replace(/\b\w/g, (l) => l.toUpperCase());

                                // ✅ Mostrar typename sin "Fix"
                                if (key === "__typename") {
                                    const cleanType = value.replace(/Fix$/, ""); // elimina "Fix" del final
                                    return (
                                        <p key={key}>
                                            <strong> Item Name:</strong> {cleanType}
                                        </p>
                                    );
                                }

                                // ✅ Si el valor es un objeto con nombre
                                if (
                                    typeof value === "object" &&
                                    value !== null &&
                                    value.first_name &&
                                    value.last_name
                                ) {
                                    return (
                                        <p key={key}>
                                            <strong>{formatLabel}:</strong> {capitalize(value.first_name)} {capitalize(value.last_name)}
                                        </p>
                                    );
                                }

                                return (
                                    <p key={key}>
                                        <strong>{formatLabel}:</strong>{" "}
                                        {value instanceof Date
                                            ? value.toLocaleDateString()
                                            : typeof value === "boolean"
                                                ? value ? "Yes" : "No"
                                                : String(value)}
                                    </p>
                                );
                            })}

                            <button className="add-inventory-btn" onClick={() => setShowOverlay(false)}>Close</button>
                        </div>
                    </div>
                )}




            </div>
        </div>

    )


};

export default Inventory_Home;
